import { render, staticRenderFns } from "./SlotSwitchList_comp.vue?vue&type=template&id=c547d82e&scoped=true&"
import script from "./SlotSwitchList_comp.vue?vue&type=script&lang=js&"
export * from "./SlotSwitchList_comp.vue?vue&type=script&lang=js&"
import style0 from "./SlotSwitchList_comp.vue?vue&type=style&index=0&id=c547d82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c547d82e",
  null
  
)

export default component.exports